import React, { Component } from 'react';
import 'HELPDESK/Components/CoordinatorDetails/coordinatordetails.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';
import { Base64, fromBase64, toBase64 } from 'js-base64';
import { ReactDOM } from 'react';
import { Link } from 'react-router-dom';
import CoordinatorDetails from './CoordinatorDetails';

class ModulePresentation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coordinatorFetching: false,
            coordinatorList: {},
            moduleListWithDemoPoint: {},
            filterName: '',
            pageIndex: 1,
            limit: 10,
            offset: 0,
            coordinatorCount: 0,
            containerId: "",

            // VARIABLES TO GET EMPLOYEE LIST
            employeeFetching: false,
            employeeList: {},
            searchTerm: '',

            // VARIABLES TO GET DEPARTMENT LIST
            departmentList: {},

            // VARIABLES TO GET MODULE LIST
            moduleFetching: false,
            moduleList: {},

            // VARIABLES TO ADD COORDINATOR
            addCoordinator: false,
            addingCoordinator: false,
            selectModule: false,
            tempSelectedModule: '',
            tempSelectedModuleName: '',
            selectedModule: '',
            selectedModuleName: '',
            moduleWarning: '',
            selectEmployee: false,
            tempSelectedEmployeeId: '',
            tempSelectedEmployeeName: '',
            selectedEmployeeId: '',
            selectedEmployeeName: '',
            selectedDepartmentIds: [],
            employeeWarning: '',

            // VARIABLES TO DELETE COORDINATOR 
            deleteCoordinator: false,
            moduleUniqueId: '',
            coordinatorId: '',

            //VARIABLES FOR ACCESS
            accessResponse: '',
            onboardingAccess: false,
            adminName: '',

            // VARIABLES FOR DEMO POINT ATTACHMENTS
            viewAttachment: false,
            attachmentArray: [],
            selectedAttachmentFile: '',
            currentAttachmentIndex: 0,

            // VARIABLES TO VIEW DETAILED PRESENTATION
            detailedPresentation: false,
            detailedModuleList: {},
            currentModuleId: '',
            currentModuleName: '',

            // VARIABLES TO SHIFT SUB MODULE
            currentSubModuleObject: {},
            subModuleIds: [],
            currentSubModuleId: '',
            currentSubModuleIndex: 0,
            subModuleNameObject: {},

            // VARIABLES TO SHIFT POINT
            currentPointIds: [],
            currentPointId: '',
            currentPointIndex: 0,
            currentPointNameObject: {},

            // VARIABLES TO SHIFT ATTACHMENT
            currentAttachmentArray: [],
            currentAttachmentPath: '',
            currentAttachmentIdx: 0,

            // VARIABLES TO COLLAPSE TABLE CONTENT
            collapseStatus: 'expanded',
            currentPointDetails: {},
        };
    }

    componentDidMount() {

        // API CALL METHOD TO GET MODULE DETAILS
        this.apiCallToGetModuleList();

        // METHOD CALLED TO GET INSTRUCTOR QUERIES COUNT
        this.apiCallToGetHelpDeskAccess();

        // API CALL METHOD TO GET MODULE DETAILS WITH DEMO POINT
        // this.apiCallToGetModuleListWithDemoPoint();
    }

    componentDidUpdate() {

        if (this.state.detailedPresentation) {
            document.onkeydown = (e) => {
                if (e.keyCode == 37) {
                    // METHOD TO GET PREVIOUS SUBMODULE POINT DETAILS
                    this.getPreviousPresentation();
                } else if (e.keyCode == 39) {
                    // METHOD TO GET NEXT SUBMODULE POINT DETAILS
                    this.getNextPresentation();
                }
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleList = async () => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "department": '',
            // "search": this.state.searchTerm
        };

        // let jsonResponse = await HelpdeskApiCall.makeApiCall(
        //     'GetPMCurrentSubscriptionWiseModuleList',
        //     requestData,
        //     '/api/helpDesk/employee/Onboarding.php'
        // );

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMInstituteModuleList',
            requestData,
            '/api/projectManagement/settings/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    moduleFetching: false,
                    moduleList: apiResult
                });
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET HELP DESK ACCESS
    apiCallToGetHelpDeskAccess = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskAccessDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetHelpDeskAccess()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let accessResponse = jsonResponse.APIResult.access_provided;
                let onboardingAccess = accessResponse.helpDeskOnboarding.isAccessGranted == "true" ? true : false;

                let adminName = accessResponse.adminName;

                let manageOnboardingName = new Set();
                let helpDeskOnboardingAccessGranted = accessResponse.helpDeskOnboarding.accessGrantedTo;
                helpDeskOnboardingAccessGranted.map(facultyData => {
                    manageOnboardingName.add(facultyData.name);
                });

                this.setState({
                    accessResponse,
                    onboardingAccess,
                    adminName,
                });
            } else {
                this.setState({
                    instructorListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting instructor list with query count. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleListWithDemoPoint = async (selectedModuleId) => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "filter_module": selectedModuleId,
            // "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleLSubmoduleListWithPoints',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleListWithDemoPoint(selectedModuleId)
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    moduleFetching: false,
                    moduleListWithDemoPoint: apiResult,
                    detailedModuleList: apiResult
                },
                    () => this.setModuleDemoPointData(selectedModuleId)
                );
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO RETURN VIEW DETAILED PRESENTATION
    returnViewDetailedPresentation = () => {
        return (
            <div className={this.state.detailedPresentation ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog viewDetailedPresentation-dialog">
                    <div className="modal-content viewDetailedPresentation-content">
                        <div className="modal-body viewDetailedPresentation-body">
                            <div className="detailedPresentationContainer">
                                {
                                    this.state.collapseStatus == 'expanded' ?
                                        <div className='detailedPresentationPoint' id="detailedPointContainer">
                                            <div className="tableContentHeader">
                                                <p>Table of Content for {this.state.currentModuleName}</p>
                                                <FontAwesomeIcon icon={['fas', 'angle-double-left']} size="lg" color="#B4B4BB" style={{ cursor: 'pointer' }} onClick={() => this.setState({ collapseStatus: 'collapsed' })} />
                                            </div>
                                            <div className="subModuleListContainer">
                                                {
                                                    Object.keys(this.state.currentSubModuleObject).length > 0 ?
                                                        this.state.subModuleIds.map((subModuleId, subModuleIndex) => {
                                                            let subModule = this.state.currentSubModuleObject[subModuleId]
                                                            return (
                                                                <div className="subModulePointDetails">
                                                                    <p className="detailedSubModuleName">{subModuleIndex + 1}. {subModule.module_name}</p>
                                                                    <div className="pointListDetails">
                                                                        {
                                                                            subModule.demoPointSequence.length > 0 &&
                                                                            subModule.demoPointSequence.map((pointId, pointIndex) => {

                                                                                let point = subModule['demo_point'][pointId];

                                                                                return (
                                                                                    <>
                                                                                        <p className={this.state.currentPointId == point.unique_id ? 'selectedPointName detailedPointName' : "detailedPointName"} onClick={() => this.setCurrentPoint(subModule.unique_id, subModuleIndex, point.unique_id, pointIndex)}>{ReactHtmlParser(point.point)}</p>
                                                                                    </>
                                                                                );
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                        :
                                                        <p style={{ fontSize: 14, marginTop: 20, color: '#818181' }}>No sub module is yet added to <span style={{ fontWeight: 'bold' }}>{this.state.currentModuleName}</span>.</p>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className='detailedPresentationPointCollapsed' id="detailedPointContainer">
                                            <FontAwesomeIcon icon={['fas', 'angle-double-right']} style={{ cursor: 'pointer' }} size="lg" color="#B4B4BB" onClick={() => this.setState({ collapseStatus: 'expanded' })} />
                                        </div>
                                }
                                <div className={this.state.collapseStatus == 'expanded' ? "detailedPresentationAttachment" : "detailedPresentationAttachmentFull"}>
                                    <div className="attachmentHeader">
                                        {this.state.currentSubModuleIndex + 1}.
                                        <span style={{ borderRight: this.state.subModuleNameObject[this.state.currentSubModuleId] ? '1px solid #818181' : 'none', paddingRight: 10 }}>{this.state.currentModuleName}</span>
                                        {
                                            this.state.subModuleNameObject[this.state.currentSubModuleId] &&
                                            <span>{this.state.subModuleNameObject[this.state.currentSubModuleId]}</span>
                                        }
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', height: 'inherit',marginTop:'4px',overflowY:'auto',maxHeight:'80vh' }}>
                                        <div className="d-flex flex-column gap-3">
                                            <p className="vm_custom_body4" style={{ color: '#000000' }}> Demo Point Title</p>
                                            <p className="vm_custom_body5 pl-2">{ReactHtmlParser(this.state.currentPointDetails?.point)}</p>

                                        </div>
                                        <div className="d-flex flex-column gap-3">
                                            <p className="vm_custom_body4" style={{ color: '#000000' }}   >Explanation</p>
                                            <p className="vm_custom_body5 pl-2">{ReactHtmlParser(this.state.currentPointDetails?.explanation)}</p>

                                        </div>
                                        <div className="d-flex flex-column gap-3">
                                            <p className="vm_custom_body4" style={{ color: '#000000' }}>Contents</p>
                                            <div className="detailedAttachmentView">
                                                {
                                                    this.state.currentAttachmentArray.length > 0 ? (() => {

                                                        const fileName = this.state.currentAttachmentArray[this.state.currentAttachmentIdx];
                                       
                                                        const fileUrl = `${this.state.currentAttachmentPath}/${fileName}`;
                                                        const extension = fileName.split('.').pop().toLowerCase();
                                                        const videoExtensions = ['mp4', 'webm', 'ogg'];

                                                        if (videoExtensions.includes(extension)) {
                                                            return (
                                                                <iframe
                                                                    title="Video Attachment"
                                                                    src={fileUrl}
                                                                    width="100%"
                                                                    height="400px"
                                                                    allow="autoplay; encrypted-media"
                                                                    allowFullScreen
                                                                    frameBorder="0"
                                                                />
                                                            );
                                                        } else {
                                                            
                                                            return (
                                                                <img
                                                                    alt="Attachment"
                                                                    src={fileUrl}
                                                                    width="100%"
                                                                    height="100%"
                                                                />
                                                            );
                                                        }
                                                    })()
                                                        :
                                                        <p style={{ marginTop: 30, fontSize: 14, color: '#818181' }}>
                                                            Content not available.
                                                        </p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.state.collapseStatus == 'collapsed' ? 'attachmentActionButtonsFull' : 'attachmentActionButtons'}>
                                        <div className="nextPreviousButtons">
                                            <FontAwesomeIcon icon={['fas', 'chevron-circle-left']} size="lg" color="#0465AC" style={{ cursor: 'pointer', opacity: (Object.keys(this.state.currentSubModuleObject).length == 0 || this.state.currentPointIds.length == 0 || (this.state.currentSubModuleIndex == 0 && this.state.currentPointIndex == 0 && this.state.currentAttachmentIdx == 0)) ? 0.5 : 1 }} onClick={(e) => (Object.keys(this.state.currentSubModuleObject).length == 0 || this.state.currentPointIds.length == 0 || (this.state.currentSubModuleIndex == 0 && this.state.currentPointIndex == 0 && this.state.currentAttachmentIdx == 0)) ? e.preventDefault() : this.getPreviousPresentation()} />
                                            <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="lg" color="#0465AC" style={{ cursor: 'pointer', opacity: (Object.keys(this.state.currentSubModuleObject).length == 0 || ((parseInt(this.state.subModuleIds[this.state.subModuleIds.length - 1]) == this.state.currentSubModuleId) && (parseInt(this.state.currentPointIds[this.state.currentPointIds.length - 1]) == this.state.currentPointId) && (this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : this.state.currentAttachmentArray.length - 1)))) ? 0.5 : 1 }} onClick={(e) => (Object.keys(this.state.currentSubModuleObject).length == 0 || ((parseInt(this.state.subModuleIds[this.state.subModuleIds.length - 1]) == this.state.currentSubModuleId) && (parseInt(this.state.currentPointIds[this.state.currentPointIds.length - 1]) == this.state.currentPointId) && (this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : this.state.currentAttachmentArray.length - 1)))) ? e.preventDefault() : this.getNextPresentation()} />
                                        </div>
                                        {

                                        }
                                        {
                                            (this.props.moduleId != undefined && this.props.source == "helpDesk") &&
                                            <div className="closeViewButtonContainer">
                                                <p className="closeViewButton" onClick={() => this.closeDetailedPresentation()}>
                                                    Close
                                                </p>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SET CURRENT POINT
    setCurrentPoint = (subModuleId, subModuleIndex, pointId, pointIndex) => {
        let currentSubModuleObject = this.state.currentSubModuleObject;


        let attachmentArray = [];
        let attachmentPath = '';
        let demoPointSequence = [];
        let currentPointDetails = {};

        if (currentSubModuleObject[subModuleId] != undefined) {
            let pointObject = currentSubModuleObject[subModuleId].demo_point;
            demoPointSequence = currentSubModuleObject[subModuleId].demoPointSequence;

            if (pointObject[pointId] != undefined) {
                let pointDetails = pointObject[pointId];

                attachmentPath = pointDetails.attachmentPath;
                currentPointDetails = pointDetails;

                if (pointDetails.attachments == undefined || pointDetails.attachments == null) {
                    attachmentArray = [];
                } else {
                    attachmentArray = pointDetails.attachments.split(',');
                }
            }
        }

        this.setState({
            currentSubModuleId: subModuleId,
            currentSubModuleIndex: subModuleIndex,
            currentPointId: pointId,
            currentPointIndex: pointIndex,
            currentAttachmentIdx: 0,
            currentPointIds: demoPointSequence,
            currentAttachmentArray: attachmentArray,
            currentAttachmentPath: attachmentPath,
            currentPointDetails: currentPointDetails
        });
    }

    // VARIABLES TO GET PREVIOUS PRESENTATION
    getPreviousPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;
        if (this.state.currentAttachmentIdx == 0) {
            if (this.state.currentPointIndex == 0) {
                if (this.state.currentSubModuleIndex > 0) {
                    this.setPreviousSubModuleDemoPointDetails();
                }
            } else {
                let currentPointIndex = this.state.currentPointIndex - 1;
                let currentPointId = this.state.currentPointIds[currentPointIndex];

                let point = currentSubModuleObject[this.state.currentSubModuleId].demo_point[currentPointId];

                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: attachmentArray.length == 0 ? 0 : attachmentArray.length - 1,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }
        } else {
            this.setState({
                currentAttachmentIdx: this.state.currentAttachmentIdx - 1
            });
        }
    }

    // VARIABLES TO GET NEXT PRESENTATION
    getNextPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;
        if (this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : (this.state.currentAttachmentArray.length - 1))) {
            if (this.state.currentPointIndex == (this.state.currentPointIds.length - 1)) {
                if (this.state.currentSubModuleIndex != (this.state.subModuleIds.length - 1)) {
                    this.setNextSubModuleDemoPointDetails();
                }
            } else {
                let currentPointIndex = this.state.currentPointIndex + 1;
                let currentPointId = this.state.currentPointIds[currentPointIndex];

                let point = currentSubModuleObject[this.state.currentSubModuleId].demo_point[currentPointId];

                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }
        } else {
            this.setState({
                currentAttachmentIdx: this.state.currentAttachmentIdx + 1
            });
        }
    }

    // METHOD TO CLOSE DETAILED PRESENTATION
    closeDetailedPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;

        let currentSubModuleIndex = 0;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if (currentSubModuleObject[currentSubModuleId] != undefined) {
            if (Object.keys(currentSubModuleObject[currentSubModuleId].demo_point).length > 0) {
                let demoPoints = currentSubModuleObject[currentSubModuleId].demoPointSequence;

                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let attachments = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachmentPath;

                this.setState({
                    currentSubModuleIndex: 0,
                    currentSubModuleId: currentSubModuleId,
                    currentPointIndex: 0,
                    currentPointId: currentPointId,
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0
                });
            } else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO SET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }

        this.setState({
            detailedPresentation: false
        });

        this.props.closeDetailedPresentation();
    }

    // METHOD TO SET PREVIOUS SUBMODULE DEMO POINT DETAILS
    setPreviousSubModuleDemoPointDetails = () => {
        let currentSubModuleIndex = this.state.currentSubModuleIndex - 1;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if (this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
            let demoPoints = this.state.currentSubModuleObject[currentSubModuleId].demoPointSequence;

            if (demoPoints.length > 0) {
                let currentPointIndex = demoPoints.length - 1;
                let currentPointId = demoPoints[currentPointIndex];

                if (this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
                    let point = this.state.currentSubModuleObject[currentSubModuleId].demo_point[currentPointId];

                    let attachments = point.attachments;
                    let attachmentArray = attachments == null ? [] : attachments.split(',');
                    let attachmentPath = point.attachmentPath;

                    this.setState({
                        currentAttachmentArray: attachmentArray,
                        currentSubModuleIndex: currentSubModuleIndex,
                        currentSubModuleId: currentSubModuleId,
                        currentAttachmentPath: attachmentPath,
                        currentAttachmentIdx: attachmentArray.length == 0 ? 0 : attachmentArray.length - 1,
                        currentPointIds: demoPoints,
                        currentPointIndex: currentPointIndex,
                        currentPointId: currentPointId
                    });
                }
            } else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO GET PREVIOUS SUB MODULE DETAILS
                    this.setPreviousSubModuleDemoPointDetails();
                });
            }
        }
    }

    // METHOD TO SET NEXT SUBMODULE DEMO POINT DETAILS
    setNextSubModuleDemoPointDetails = () => {

        let currentSubModuleIndex = this.state.currentSubModuleIndex + 1;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if (this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
            let demoPoints = this.state.currentSubModuleObject[currentSubModuleId].demoPointSequence;

            if (demoPoints.length > 0) {
                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let point = this.state.currentSubModuleObject[currentSubModuleId].demo_point[currentPointId];

                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0,
                    currentPointIds: demoPoints,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            } else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO GET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }
    }

    returnPresentationData = () => {
        let moduleData = {};
        if (this.props.match != undefined) {
            let moduleId = fromBase64(this.props.match.params.module);

            if (Object.keys(this.state.moduleList).length > 0 || this.state.moduleList.length > 0) {
                Object.values(this.state.moduleList).map(module => {
                    if (parseInt(module.unique_id) == parseInt(moduleId)) {
                        moduleData = module;
                    }
                });
            }

            if (Object.keys(moduleData).length > 0 && this.state.detailedPresentation == false && (parseInt(this.state.tempSelectedModule) != parseInt(moduleId))) {
                this.setState({
                    detailedPresentation: true
                },
                    (e) => this.selectModule(e, moduleData)
                );
            }
        }
        else if (this.props.moduleId != undefined && this.props.moduleId != '') {
            let moduleId = this.props.moduleId;

            if (Object.keys(this.state.moduleList).length > 0 || this.state.moduleList.length > 0) {
                Object.values(this.state.moduleList).map(module => {
                    if (parseInt(module.unique_id) == parseInt(moduleId)) {
                        moduleData = module;
                    }
                });
            }

            if (Object.keys(moduleData).length > 0 && this.state.detailedPresentation == false && (parseInt(this.state.tempSelectedModule) != parseInt(moduleId))) {
                this.setState({
                    detailedPresentation: true
                },
                    (e) => this.selectModule(e, moduleData)
                );
            }
        }
    }

    // METHOD TO SELECT MODULE DETAILS
    selectModule = (e, module) => {

        this.apiCallToGetModuleListWithDemoPoint(module.unique_id);

        this.setState({
            tempSelectedModule: module.unique_id,
            tempSelectedModuleName: module.module_name,
            currentModuleId: module.unique_id,
            currentModuleName: module.module_name
        });
    }

    // METHOD TO SET MODULE DEMO POINT DETAILS
    setModuleDemoPointData = (moduleId) => {
        let attachmentArray = this.state.attachmentArray;
        let moduleListWithDemoPoint = this.state.moduleListWithDemoPoint;
        let subModuleNameObject = this.state.subModuleNameObject;
        let currentPointNameObject = this.state.currentPointNameObject;

        subModuleNameObject = {};
        currentPointNameObject = {};

        attachmentArray = [];

        if (moduleListWithDemoPoint[moduleId] != undefined) {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];

            if (Object.keys(subModules).length > 0) {
                Object.values(subModules).map(subModule => {
                    let demoPoint = subModule.demo_point;
                    let demoPointSequence = subModule.demoPointSequence;

                    if (Object.keys(demoPoint).length > 0) {
                        demoPointSequence.map(pointId => {
                            let point = demoPoint[pointId] != undefined ? demoPoint[pointId] : {};
                            let attachmentPath = point.attachmentPath != undefined ? point.attachmentPath : "";
                            let attachment = point.attachments != "" && point.attachments != null ? point.attachments.split(",") : [];

                            if (attachment.length > 0) {
                                attachment.map(file => {
                                    let fileName = attachmentPath + "/" + file;

                                    attachmentArray.push(fileName);
                                })
                            }
                        });
                    }
                });
            }
        }

        if (moduleListWithDemoPoint[moduleId] != undefined) {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];
            let subModuleIds = moduleListWithDemoPoint[moduleId]['subModuleSequenceIdArray']
            if (Object.keys(subModules).length > 0) {
                subModuleIds.map((subModuleId, subModuleIndex) => {
                    if (subModuleIndex == 0) {
                        if (Object.keys(subModules[subModuleId].demo_point).length > 0) {
                            let demoPointSequence = subModules[subModuleId].demoPointSequence;
                            demoPointSequence.map((pointId, pointIndex) => {
                                if (pointIndex == 0) {
                                    let attachments = subModules[subModuleId].demo_point[pointId].attachments;
                                    let attachmentArray = attachments == null ? [] : attachments.split(',');
                                    
                                    let currentPointDetails = subModules[subModuleId].demo_point[pointId];



                                    this.setState({
                                        currentAttachmentArray: attachmentArray,
                                        currentAttachmentPath: subModules[subModuleId].demo_point[pointId].attachmentPath,
                                        currentAttachmentIdx: 0,
                                        currentPointId: pointId,
                                        currentPointIds: demoPointSequence,
                                        currentPointIndex: pointIndex,
                                        currentPointDetails: currentPointDetails
                                    });
                                }

                                currentPointNameObject[pointId] = subModules[subModuleId].demo_point[pointId].point;
                            });

                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            });
                        } else {
                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            }, () => {
                                // METHOD TO GET NEXT SUBMODULE DETAILS
                                this.setNextSubModuleDemoPointDetails();
                            });
                        }
                    }

                    subModuleNameObject[subModuleId] = subModules[subModuleId].module_name;
                });
            }

            this.setState({
                subModuleIds,
                currentSubModuleObject: subModules
            });
        } else {
            this.setState({
                currentAttachmentArray: [],
                currentAttachmentPath: ''
            });
        }

        this.setState({
            attachmentArray,
            subModuleNameObject,
            currentPointNameObject
        });
    }

    render() {
        return (
            <>
                {
                    this.returnViewDetailedPresentation()
                }
                {
                    this.returnPresentationData()
                }
            </>
        )
    }
}

export default ModulePresentation;